import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import InputField from '../../../../components/InputField/InputField';
import TextAreaField from '../../../../components/TextAreaField';

interface FAQFormData {
    question: string;
    answer: string;
    order: number;
}

interface GeneralFAQProps {
    faqForm: FAQFormData;
    setFaqForm: (faq: FAQFormData) => void;
    errorFields?: any;
    isCreate?: boolean;
}

const FAQForm = ({
    faqForm,
    setFaqForm,
    errorFields,
    isCreate = false
}: GeneralFAQProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    return (
        <div className="row">
            <div className="col-12 mb-3">
                <TextAreaField
                    label="Pregunta"
                    value={faqForm.question}
                    onChange={(value) => setFaqForm({ ...faqForm, question: value })}
                    onFocus={() => onFocusRemove('question')}
                    error={fieldErrorMessage('question')}
                    rows={3}
                    placeholder="Ingrese la pregunta..."
                    required
                />
            </div>
            
            <div className="col-12 mb-3">
                <TextAreaField
                    label="Respuesta"
                    value={faqForm.answer}
                    onChange={(value) => setFaqForm({ ...faqForm, answer: value })}
                    onFocus={() => onFocusRemove('answer')}
                    error={fieldErrorMessage('answer')}
                    rows={6}
                    placeholder="Ingrese la respuesta..."
                    required
                />
            </div>
            
            <div className="col-md-3 mb-3">
                <InputField
                    label="Orden"
                    type="number"
                    value={faqForm.order.toString()}
                    onChange={(value) => setFaqForm({ ...faqForm, order: parseInt(value) || 0 })}
                    onFocus={() => onFocusRemove('order')}
                    error={fieldErrorMessage('order')}
                    placeholder="0"
                    required
                />
                <small className="form-text text-muted">
                    Menor número aparece primero
                </small>
            </div>
        </div>
    );
};

export default FAQForm;

